<template>
  <div class="central_content">
    <div class="query-c" style="display: flex; align-items: center">
      手机号：
      <Input
        style="width: 200px"
        v-model="keyword"
        @input="changeInput()"
        search
        placeholder="请输入手机号"
      />
    </div>
  </div>
</template>

<script>
import { api } from "../biz/api";
export default {
  name: "home",
  data() {
    return {};
  },
  mounted: function () {
    this.getData();
  },
  methods: {
    getData() {},
  },
};
</script>

<style scoped>
</style>